import { Link } from 'react-router-dom';
import { Modal } from '@atoms/Modal';
import { Button } from '@atoms/Button';
import { useOrderSuccessStore } from '@store/uiStore';

export function OrderSuccessModal() {
  const { orderId, closeOrderSuccess } = useOrderSuccessStore();

  return (
    <Modal open={Boolean(orderId)} onClose={closeOrderSuccess} title="Sipariş Alındı">
      <div className="space-y-4 text-center">
        <div className="text-5xl">✅</div>
        <p className="text-gray-700">
          Siparişiniz başarıyla oluşturuldu.
          {orderId && (
            <span className="mt-1 block text-sm text-gray-500">
              Sipariş No: #{orderId.slice(0, 8)}
            </span>
          )}
        </p>
        <div className="flex flex-col gap-2">
          <Link to="/restaurant?tab=orders" onClick={closeOrderSuccess}>
            <Button fullWidth>Siparişlerime Git</Button>
          </Link>
          <Button variant="outline" fullWidth onClick={closeOrderSuccess}>
            Kapat
          </Button>
        </div>
      </div>
    </Modal>
  );
}
